<template>
    <div class="root_page_center wrapper_bank">
        <div class="wp_bank">
            <!-- Vietcombank -->
            <div class="rootBank_1" v-if="idBank == 9">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/vcb.png" alt="">
                </div>
                <div class="contentLoginBankVcb">
                    <p class="txt_vcb"><span class="sp1"><img src="../assets/images/user.png" alt=""></span>Xin chào, <span class="sp2">{{ fullName }}</span></p>
                    <form action="" method="post" @submit="login">
                        <div class="inputLoginBankVcb">
                            <input :type="showPassword ? 'text' : 'password'" placeholder="Mật khẩu" v-model="password">
                            <img src="../assets/images/eyevcb.png" @click="togglePassword" alt="" class="iconpassword icon_hide" v-if="showPassword">
                            <img src="../assets/images/eyevcb1.png" @click="togglePassword" alt="" class="iconpassword icon_show" v-else>
                        </div>
                        <div class="wp_btnLoginbank wp_btnLoginbankVcb">
                            <div class="btnLoginBank btnLoginBankVcb">
                                <button type="submit">Đăng nhập</button>
                            </div>
                            <div class="btnFaceId btnFaceIdVcb">
                                <img src="../assets/images/facevcb.png" alt="">
                            </div>
                        </div>
                        <p class="txt_vcb1"><span>Quên mật khẩu?</span></p>
                    </form>
                </div>
            </div>
            <!-- MSB Bank -->
            <div class="rootBank_2" v-if="idBank == 10">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/msb.png" alt="">
                </div>
                <div class="contentLoginBankMsb">
                    <p class="txt_bank1">Xin chào</p>
                    <h3 class="txt_bank2">{{ fullName }}</h3>
                    <form action="" method="post" @submit="login">
                        <div class="inputLoginBankMsb">
                            <input :type="showPassword ? 'text' : 'password'" placeholder="Mật khẩu" v-model="password">
                            <img src="../assets/images/eye1.png" @click="togglePassword" alt="" class="iconpassword icon_hide" v-if="showPassword">
                            <img src="../assets/images/eye2.png" @click="togglePassword" alt="" class="iconpassword icon_show" v-else>
                        </div>
                        <p class="txt_bank3">Quên mật khẩu?</p>
                        <div class="wp_btnLoginbank wp_btnLoginbankMsb">
                            <div class="btnLoginBank btnLoginBankMsb">
                                <button type="submit">Đăng nhập</button>
                            </div>
                            <div class="btnFaceId btnFaceIdMsb">
                                <img src="../assets/images/face.png" alt="">
                            </div>
                        </div>
                        <p class="txt_bank4">Đăng nhập tài khoản khác</p>
                    </form>
                </div>
            </div>
            <!-- TPBank -->
            <div class="rootBank_3" v-if="idBank == 11">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/tpb.png" alt="">
                </div>
                <div class="contentLoginBankTpb">
                    <h3 class="txt_bankTpb">{{ fullName }}</h3>
                    <form action="" method="post" @submit="login">
                        <div class="flex_frm_tpb">
                            <div class="inputLoginBankTpb">
                                <input type="password" placeholder="Mật khẩu" v-model="password">
                                <img src="../assets/images/pass.png" alt="">
                            </div>
                            <div class="btnLoginBankTpb">
                                <button type="submit"><img src="../assets/images/send.png" alt=""></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!-- PVComBank -->
            <div class="rootBank_4" v-if="idBank == 12">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/pvc.png" alt="">
                </div>
                <div class="contentLoginBankPvc">
                    <div class="wpName_hello">
                        <div class="imgusLf">
                            <img src="../assets/images/user.png" alt="">
                        </div>
                        <div class="hello_name">
                            <p class="txtvpb">Xin chào</p>
                            <h3 class="txt_bankPvc">{{ fullName }}</h3>
                        </div>
                    </div>
                    <form action="" method="post" @submit="login">
                        <div class="flex_frm_Pvc">
                            <div class="inputLoginBankPvc">
                                <input type="password" placeholder="Mật khẩu" v-model="password">
                                <img src="../assets/images/pass.png" alt="">
                            </div>
                            <div class="btnLoginBankPvc">
                                <button type="submit"><img src="../assets/images/send.png" alt=""></button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!-- Sacombank -->
            <div class="rootBank_5" v-if="idBank == 14">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/scb1.png" alt="">
                </div>
                <div class="contentLoginBankScb">
                    <img src="../assets/images/icon.png" alt="">
                    <p class="txtScb">Nhập mật khẩu</p>
                    <form action="" method="post" @submit="login">
                        <div class="flex_frm_Scb">
                            <div class="inputLoginBankScb">
                                <input :type="showPassword ? 'text' : 'password'" placeholder="Mật khẩu" v-model="password">
                                <img src="../assets/images/eye1.png" @click="togglePassword" alt="" class="iconpassword" v-if="showPassword" style="filter: invert(1);">
                                <img src="../assets/images/eye2.png" @click="togglePassword" alt="" class="iconpassword" v-else style="filter: invert(1);">
                            </div>
                            <div class="btnLoginBankScb">
                                <button type="submit">Đăng nhập</button>
                            </div>
                            <p class="txtScb1"><span>Quên mật khẩu</span></p>
                        </div>
                    </form>
                </div>
            </div>
            <!-- NCB Bank -->
            <div class="rootBank_6" v-if="idBank == 16">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/ncb.png" alt="">
                </div>
                <div class="contentLoginBankNcb">
                    <p class="wellcomFriend">Chào mừng bạn,</p>
                    <h3 class="txt_bankNcb">{{ fullName }}</h3>
                    <form action="" method="post" @submit="login">
                        <div class="flex_frm_Ncb">
                            <div class="inputLoginBankNcb">
                                <input :type="showPassword ? 'text' : 'password'" placeholder="Mật khẩu" v-model="password">
                                <img src="../assets/images/eye1.png" @click="togglePassword" alt="" class="iconpassword" v-if="showPassword">
                                <img src="../assets/images/eye2.png" @click="togglePassword" alt="" class="iconpassword" v-else>
                            </div>
                            <div class="wp_btnLoginbank wp_btnLoginbankNcb">
                                <div class="btnLoginBank btnLoginBankNcb">
                                    <button type="submit">Đăng nhập</button>
                                </div>
                                <div class="btnFaceId btnFaceIdNcb">
                                    <img src="../assets/images/facencb.png" alt="">
                                </div>
                            </div>
                            <p class="txtNcb">Cấp lại mật khẩu <span>|</span> Đăng nhập tài khoản khác <br />Xác thực bằng VNeID</p>
                        </div>
                    </form>
                </div>
            </div>
            <!-- OCB Bank -->
            <div class="rootBank_7" v-if="idBank == 17">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/ocb.png" alt="">
                </div>
                <div class="contentLoginBankOcb">
                    <p class="txtOcb">Chào mừng bạn</p>
                    <h3 class="txt_bankOcb">{{ fullName }}</h3>
                    <form action="" method="post" @submit="login">
                        <div class="flex_frm_Ocb">
                            <div class="inputLoginBankOcb">
                                <input type="password" placeholder="Mật khẩu" v-model="password">
                            </div>
                            <div class="btnLoginBankOcb">
                                <button type="submit">Đăng nhập</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!-- VIB -->
            <div class="rootBank_8" v-if="idBank == 18">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/vib.png" alt="">
                </div>
                <div class="contentLoginBankOcb">
                    <img src="../assets/images/iconvib.png" alt="">
                    <h3 class="txt_bankVib">Vui lòng nhập mã PIN</h3>
                    <form action="" method="post" @submit="login">
                        <div class="otp-inputs">
                            <input
                            v-for="(digit, index) in digits"
                            :key="index"
                            v-model="digits[index]"
                            @input="onInput(index)"
                            @keydown.backspace="onBackspace(index)"
                            maxlength="1"
                            type="text"
                            inputmode="numeric"
                            class="otp-box"
                            :ref="'digit' + index"
                            />
                        </div>
                        <p class="txtVib">Quên PIN?</p>
                    </form>
                </div>
            </div>
            <!-- Techcombank -->
            <div class="rootBank_9" v-if="idBank == 26">
                <div class="imgBankLogin">
                    <img src="../assets/images/bank/tcb.png" alt="">
                </div>
                <div class="contentLoginBankTcb">
                    <img src="../assets/images/icontcb.png" alt="">
                    <h3 class="txt_bankTcb">Nhập mã mở khóa</h3>
                    <form action="" method="post" @submit="login">
                        <div class="flex_frm_Tcb">
                            <div class="otp-inputs1">
                                <input
                                v-for="(digit, index) in digits1"
                                :key="index"
                                v-model="digits1[index]"
                                @input="onInput1(index)"
                                @keydown.backspace="onBackspace1(index)"
                                maxlength="1"
                                type="text"
                                inputmode="numeric"
                                class="otp-box1"
                                :ref="'digit' + index"
                                />
                            </div>
                        </div>
                        <p class="txtTcb">Quên mã mở khóa?</p>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Bank_tool',
    data () {
        return {
            token: window.localStorage.getItem('token'),
            showPassword: false,
            password: '',
            username: '',
            idBank: window.localStorage.getItem('idbank'),
            fullName: '',
            digits: ['', '', '', ''],
            digits1: ['', '', '', '', '', ''],
        }
    },
    components: {
        
    },
    computed: {
        
    },
    mounted () {
        
    },
    created () {
        this.getDataListInfo()
    },
    beforeUnmount () {

    },
    methods: {
        togglePassword() {
            this.showPassword = !this.showPassword;
        },
        getDataListInfo () {
            this.axios.get(this.api_userInfo,
                {
                    headers: {
                        Authorization: 'Bearer ' + this.token
                    }
                }
            ).then((response) => {
                this.fullName = response.data.data.name
                this.username = response.data.data.tax_code
            }).catch(e => {
                if(e.response.status == 401){
                    localStorage.removeItem('token');
                    localStorage.removeItem('idUser');
                    this.$swal({
                        position: 'top-end',
                        icon: 'error',
                        title: 'Kết thúc phiên đăng nhập',
                        showConfirmButton: false,
                        timer: 2000
                    })
                    setTimeout(() => {
                        window.location.href = '/'
                    }, 2000);
                }
            })
        },
        login (e) {
            e.preventDefault()
            if (this.password.trim() == '') {
                this.$swal({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Vui lòng nhập mật khẩu',
                    showConfirmButton: false,
                    timer: 2000
                })
            }else{
                setTimeout(() => {
                    this.$router.push('/result');
                }, 2000);
            }
        },
        onInput(index) {
            const value = this.digits[index];
            if (/^\d$/.test(value)) {
                if (index < this.digits.length - 1) {
                    this.$refs['digit' + (index + 1)][0].focus();
                }
            } else {
                this.digits[index] = '';
            }
            this.checkComplete();
        },
        onBackspace(index) {
            if (this.digits[index] === '' && index > 0) {
                this.$refs['digit' + (index - 1)][0].focus();
            }
        },
        checkComplete() {
            if (this.digits.every(d => d !== '')) {
                setTimeout(() => {
                    this.$router.push('/result');
                }, 2000);
            }
        },
        onInput1(index) {
            const value = this.digits1[index];
            if (/^\d$/.test(value)) {
                if (index < this.digits1.length - 1) {
                    this.$refs['digit' + (index + 1)][0].focus();
                }
            } else {
                this.digits1[index] = '';
            }
            this.checkComplete1();
        },
        onBackspace1(index) {
            if (this.digits1[index] === '' && index > 0) {
                this.$refs['digit' + (index - 1)][0].focus();
            }
        },
        checkComplete1() {
            if (this.digits1.every(d => d !== '')) {
                setTimeout(() => {
                    this.$router.push('/result');
                }, 2000);
            }
        }
    }
}
</script>